import { Divider, Drawer, Space, Button, Radio } from "antd";
import React, { useState } from "react";
import moment from "moment";
import browse_placeholder from "../../../media/browse.jpg"

export default function Browse(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    // Component agnostic
    const {
        name = "",
        container = true,
        date_changed = 0
    } = content;

    const save = () => {
        close();
        saveItem(id, { ...content })
    }

    const drawRender = () => {
        return (
            <div style={{ "textAlign": "center" }}>
                <img src={browse_placeholder} />
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => close()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent({ ...content, "container": e.target.value })} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close()} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}